import { h } from "preact";
import { t, translate, } from "restaumatic-client";
import { FulfillmentTimeOptions } from "../../components/FulfillmentTimeForm";
import PreactModal, { ModalHeader } from "../../components/PreactModal";
import { observer } from "mobx-react";
function FulfillmentTimeModal(props) {
    const { isOpen, isDelivery, fulfillmentTime, controller, onSubmit, onShown, onHidden, } = props;
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };
    return (h(PreactModal, { id: "fulfillment-time", isOpen: isOpen, onShown: onShown, onHidden: onHidden },
        h(ModalHeader, { title: isDelivery
                ? translate(t.order.delivery_time)
                : translate(t.order.pickup_time) }),
        h("div", { class: "modal-body" },
            h("form", { id: "fulfillment-time-form-modal", onSubmit: handleSubmit },
                h(FulfillmentTimeOptions, { fulfillmentTime: fulfillmentTime, controller: controller }))),
        h("div", { class: "modal-footer modal-footer--sticky" },
            h("button", { type: "submit", form: "fulfillment-time-form-modal", class: "btn btn-primary btn-block", disabled: controller.isInvalid }, translate(t.actions.save)))));
}
export default observer(FulfillmentTimeModal);
